import _ from "lodash";
import * as z from "../../framework";
import { userHasRight } from "../../framework";
import { getAvailableId } from "../../framework/components/components/component";
import { Grid } from "../../framework/dataComponents/components";
import { ComboBox } from "./components/comboBox";

// tslint:disable-next-line:no-var-requires
var loadingUrl = require("!file-loader!../../../Content/app/icon/Loading_48.GIF").default;

var Notes = function (options) {
    options = options || {};

    this.screen = options.zScreen || options.screen;
    this.zScreen = options.zScreen;
    this.observableName = options.observableName;

    var prefix = this.zScreen ? this.zScreen.id + "_" : "";
    this.newNoteId = options.newNoteId || prefix + "NewNote";
    this.insertId = options.insertId || prefix + "NoteInsert";
    this.gridId = options.gridId || prefix + "Notes";
    this.textAreaId = options.textAreaId || prefix + "NoteTextArea";
    this.editorId = options.editorId || prefix + "NoteEditor";
    this.contentAreaId = options.contentAreaId || prefix + "NoteContentArea";
    this.readOnly = options.readOnly === true;

    this.allButtonSelector = "#" + this.newNoteId + ", #" + this.insertId;
    this.selectedNoteVariableName = options.selectedNoteVariableName || "selectedNote";
    this.noteType = options.noteType || "UNDEFINED";
    this.filterIdVariable = options.filterIdVariable || this.noteType;
    this.modelId = options.modelId;
    this.modelObservableId = options.modelObservableId || "Id";
    this.noteDS = null;
    this.destinationType = null;
    this.entityType = this.noteType === "UNDEFINED" ? null : `${this.noteType}Note`;
    this.isEditor = false;
    this.preventBlur = false;

    if (options.requiredRight) {
        options.rightLocked = !userHasRight(options.requiredRight);

        if (options.rightLocked) {
            options.readOnly = true;
            this.readOnly = true;
            options.containerClasses += " right-locked";
        }
    }

    this.bindNoteEvents();
    this.initNotesGrid();

    $(`#${this.editorId}`).closest(".notes-textarea-container").hide();
    $(`#${this.editorId}`).closest(".notes-textarea-container").children("iframe").hide();
};

Notes.prototype = {
    initNotesGrid: function () {
        var me = this,
            screen = me.screen;

        var setupNoteTypeComboBoxes = function (localArgs) {
            var noteType = localArgs.noteType,
                grid = localArgs.grid,
                row = localArgs.row;

            var comboBox = new ComboBox({
                bsc: " ",
                classes: "long-input",
                readonly: me.readOnly
            });

            comboBox.render($(noteType));
            var kcb = $("#" + comboBox.id).data("kendoComboBox");
            kcb.setDataSource(z.codes.NoteType as any);

            var i = 0;
            $.each(z.codes.NoteType, function (ind, data) {
                if (data.Id == grid.dataItem(row).NoteTypeId) {
                    i = ind;
                    return false;
                }
                return true;
            });

            kcb.select(i);
            if (!me.readOnly) {
                var ignoreSet = false;
                kcb.bind("change", function (ev) {
                    if (ignoreSet) {
                        ignoreSet = true;
                        return;
                    }
                    var sender = ev.sender;
                    if (sender.value() != -1 && sender.value() != "") {
                        ignoreSet = true;
                        screen[me.selectedNoteVariableName].set("NoteTypeId", sender.value());
                        if ($.trim(screen[me.selectedNoteVariableName].Contents) != "") {
                            me.ignoreUpdate = true;
                            grid.saveChanges();
                        } else {
                            me.isFocused = true;
                            $("#" + me.textAreaId).focus();
                        }
                    }
                });

                kcb.bind("select", function (ev) {
                    var newValue = ev.sender._selectedValue,
                        oldValue = screen[me.selectedNoteVariableName].NoteTypeId;

                    if (newValue == oldValue) {
                        me.isFocused = true;
                        $("#" + me.textAreaId).focus();
                    }
                });

                $(kcb.input).tie("focus", function () {
                    grid.select(row);
                });
            }
        };

        var bindCopyToCreatedOrdersCheckbox = function (localArgs) {
            let grid = localArgs.grid,
                row = localArgs.row,
                checkbox = $(row).find("input[type=checkbox]");

            checkbox.bind("change", e => {
                const isChecked = (e.currentTarget as HTMLInputElement).checked;
                screen[me.selectedNoteVariableName].set("CopyToCreatedOrders", isChecked);
                if ($.trim(screen[me.selectedNoteVariableName].Contents) != "") {
                    me.ignoreUpdate = true;
                    grid.saveChanges();
                } else {
                    me.isFocused = true;
                    $("#" + me.textAreaId).focus();
                }
            });
        }

        var selectFirstRowOrSelectedRow = function (localArgs) {
            var grid = localArgs.grid,
                e = localArgs.e;

            if (screen[me.selectedNoteVariableName]) {
                var selectedId = screen[me.selectedNoteVariableName].Id;
                if (!selectedId) {
                    selectedId = me.updatedNoteId;
                }

                var found = false;
                var id;
                $.each(e.sender._data, function (index, data) {
                    if ((!screen[me.selectedNoteVariableName].Id && !data.Id) || data.Id == selectedId) {
                        var uid = data.uid;
                        var row = grid.tbody.find('tr[data-uid="' + uid + '"]');

                        grid.select(row);
                        found = true;
                        id = data.Id;
                        screen[me.selectedNoteVariableName] = grid.dataItem(row);
                        return false;
                    }
                });

                var textArea = $("#" + me.textAreaId);
                if (!found && !(screen[me.selectedNoteVariableName] && screen[me.selectedNoteVariableName].NewNote)) {
                    var firstRow = grid.tbody.find("tr:first");

                    if (firstRow.length > 0) {
                        grid.select(firstRow);
                    } else {
                        screen[me.selectedNoteVariableName] = null;
                        $("#" + me.contentAreaId).addClass("hidden");
                        textArea.parents(".notes-textarea-container").show();
                        textArea.val("");
                    }
                } else {
                    textArea.enable();
                }
                if (id) {
                    me.updatedNoteId = null;
                }
            } else {
                grid.select(e.sender.tbody.find("tr:first"));
            }
        };

        var noteContentArea = $("#" + this.contentAreaId);
        if (noteContentArea.length == 0) {
            noteContentArea = this.zScreen.get("#" + this.contentAreaId);
        }

        noteContentArea.on("click", ".link", function (e) {
            noteContentArea.find(".link").unbind("click");
            noteContentArea.find(".link").disable();
            var fileName = me.selectedNote.Attachment.FileName;
            z.ajax({
                url: "Attachment/ActivateAttachment?id=" + me.selectedNote.Attachment.Id,
                type: "GET",
                async: false
            }).done(function (response) {
                window.open(z.util.buildMediaUrl(response.d.results), fileName);
            }).always(function () {
                $.wait(500).then(function () {
                    noteContentArea.find(".link").bind("click");
                    noteContentArea.find(".link").enable();
                });
            });
            e.preventDefault();
        });

        const copyToCreatedOrdersColumn = () => {
            if (me.noteType == "Contract") {
                return [{
                    field: "CopyToCreatedOrders",
                    title: z.ll("CopyToCreatedOrders"),
                    template: '<div class="checkbox orderline-checkbox">' +
                                '<label class="checkbox-wrapper">' +
                                '<input type="checkbox" class="checkbox-input" # if (data.CopyToCreatedOrders) { #checked="checked"# } #/>' +
                                '<span class="checkbox-container">' +
                                '<span class="checkbox-check"></span>' +
                                "</span></label></div>",
                    menu: false
                }]
            }
            return []
        }

        me.notesGrid = $(`#${me.gridId}`).data("me") as Grid;
        me.notesGrid.build({
            id: me.gridId,
            stickyDefaultName: me.gridId,
            autoBind: false,
            autoSelect: false,
            fireChangeOnReselectIgnoreNull: true,
            entity: me.entityType,
            dataSource: me.noteDS,
            columnOrder: ["DestinationType", "CreatedUser", "CreatedDateTime", "NoteTypeId", "Contents", "MobileCreatedDateTime", me.noteType == "Contract" ? "CopyToCreatedOrders" : ""],
            gridColumns: [
                {
                    field: "DestinationType",
                    headerTemplate: "",
                    width: 45,
                    hidden: !(me.noteType == "Order" || me.noteType == "Quote"),
                    hideColumnMenu: true,
                    template:
                        "# var icon;" +
                        "switch (data.DestinationType) {" +
                        "case 'Order': #" +
                        "<span class='notes-icon-container'>" +
                        "<i class='fas fa-clipboard z-clipboard'></i>" +
                        "<i class='fas fa-pencil z-pencil'></i>" +
                        "</span>" +
                        "# break; " +
                        "case 'Quote': #" +
                        "<span class='notes-icon-container'>" +
                        "<i class='fas fa-clipboard z-clipboard'></i>" +
                        "<i class='fas fa-pencil z-pencil'></i>" +
                        "</span>" +
                        "# break; " +
                        "case 'Call': #" +
                        "<span class='notes-icon-container'>" +
                        "<i class='fas fa-phone'></i>" +
                        "</span>" +
                        "# break; } #"
                },
                {
                    field: "CreatedUser",
                    title: z.ll("User")
                },
                {
                    field: "CreatedDateTime",
                    title: z.ll("CreatedDate"),
                    template: "#=z.util.kendoFormatDateTime(data.CreatedDateTime)#"
                },
                {
                    field: "NoteTypeId",
                    title: z.ll("NoteType"),
                    template: '<span class="note-type"></span>',
                    isCode: true,
                    codeFieldIdName: "NoteTypeId",
                    codeName: "NoteType"
                },
                {
                    field: "Contents",
                    title: z.ll("Contents"),
                    filterable: {
                        operators: {
                            string: {
                                contains: z.ll("FilterableContains"),
                                doesnotcontain: z.ll("FilterableDoesnotcontain")
                            }
                        }
                    },
                    template: `# var noteType = _.find(z.codes.NoteType, (noteType) => { return noteType.Id == data.NoteTypeId; }); ##=
                        z.util.stripHTML({
                            html: data.Contents,
                            keepStyling: noteType ? noteType.IsRichText : false
                        }) #`
                },
                {
                    field: "MobileCreatedDateTime",
                    title: z.ll("MobileCreatedDateTime"),
                    template: "#= z.util.kendoFormatDateTime(data.MobileCreatedDateTime) || '---' #",
                    hidden: me.noteType != "Order",
                },
                ...copyToCreatedOrdersColumn()
            ],
            deleteButton: !this.readOnly,
            height: 228,
            editable: "inline",
            change: function (e) {
                var dataItem = e.selectedItem;
                me.selectedNote = dataItem;
                me.destinationType = (dataItem === undefined || dataItem === null) ? null : dataItem.DestinationType;
                if (!me.destinationType) {
                    me.destinationType = me.noteType;
                }

                var textAreaSelector = $(`#${me.textAreaId}`);
                var editorSelector = $(`#${me.editorId}`);

                if (dataItem) {
                    var noteType = _.find(z.codes.NoteType, nt => nt.Id == dataItem.NoteTypeId);
                    var isEditor = noteType ? noteType.IsRichText : false;

                    if (isEditor != me.isEditor) {
                        me.isEditor = isEditor;
                        me.refreshEditor();
                    }
                } else {
                    me.isEditor = false;
                }

                if (me.isEditor) {
                    editorSelector.closest(".notes-textarea-container").show();
                    editorSelector.closest(".notes-textarea-container").children("iframe").show();
                    textAreaSelector.parents(".notes-textarea-container").hide();
                } else {
                    editorSelector.closest(".notes-textarea-container").hide();
                    editorSelector.closest(".notes-textarea-container").children("iframe").hide();
                    textAreaSelector.parents(".notes-textarea-container").show();
                }

                var textArea = me.isEditor ? editorSelector : textAreaSelector;

                if (me.isFocused) {
                    if (me.isEditor) {
                        textArea.data("kendoEditor").focus();
                    } else {
                        textArea.focus();
                    }
                }

                var contentArea = $("#" + me.contentAreaId);
                if (dataItem) {
                    screen[me.selectedNoteVariableName] = dataItem;

                    var contents = screen[me.selectedNoteVariableName].Contents;
                    var value = me.isEditor ? me.readyNoteForEditor(contents) : me.readyNoteForTextArea(contents);

                    if (me.isEditor) {
                        textArea.data("kendoEditor").value(value);
                    } else {
                        textArea.val(value);
                    }

                    if (dataItem.AttachmentId && dataItem.Attachment) {
                        innerContent = '<img src="' + loadingUrl + '" class="resize-fit-center img-thumbnail">';
                        contentArea.html('<a target="_blank" class="link">' + innerContent + "</a>");

                        textArea.parents(".notes-textarea-container").hide();
                        contentArea.removeClass("hidden");

                        var fileName = dataItem.Attachment.FileName;
                        var fileExtension = fileName.substr((fileName.lastIndexOf(".") + 1));
                        var innerContent;

                        z.ajax({
                            url: "Attachment/ActivateAttachment?id=" + dataItem.Attachment.Id,
                            type: "GET"
                        }).done(function (response) {
                            if (fileExtension.isImgExtension()) {
                                innerContent = '<img src="' + z.util.buildMediaUrl(response.d.results) + '" class="resize-fit-center img-thumbnail">';
                                var id = getAvailableId();

                                $("#Main").append("<div id='" + id + "' style='position: absolute; left: -5000px; top: -5000px;'>" + innerContent + "</div>");
                                $("#" + id + " img").load(function () {
                                    $("#" + id + " img").off();
                                    $("#" + id).remove();
                                    contentArea.html('<a target="_blank" class="link">' + innerContent + "</a>");
                                });
                            } else {
                                innerContent = "Attachment: " + dataItem.Attachment.FileName;
                                contentArea.html('<a target="_blank" href="' + z.util.buildMediaUrl(response.d.results) + '" class="link">' + innerContent + "</a>");
                            }
                        });

                    } else {
                        contentArea.addClass("hidden");
                        textArea.parents(".notes-textarea-container").show();
                    }
                }
            },
            dataBound: function (e) {
                var grid = this,
                    tRows = e.sender.tbody.find("tr");
                $.each(tRows, function (index, row) {
                    var noteType = $(row).find(".note-type"),
                        rowData = grid.dataItem(row);
                    setupNoteTypeComboBoxes({
                        noteType: noteType,
                        grid: grid,
                        row: row
                    });
                    bindCopyToCreatedOrdersCheckbox({ grid, row })
                });

                if (!e.sender._data.length) {
                    me.screen.get(".notes-attachment-container").addClass("hidden");
                    $(`#${me.textAreaId}`).parents(".notes-textarea-container").show().children("textarea").val("");
                    me.isEditor = false;
                    screen[me.selectedNoteVariableName] = null;
                }

                var textAreaSelector = $(`#${me.textAreaId}`);
                var editorSelector = $(`#${me.editorId}`);

                if (me.isEditor) {
                    editorSelector.closest(".notes-textarea-container").show();
                    editorSelector.closest(".notes-textarea-container").children("iframe").show();
                    textAreaSelector.parents(".notes-textarea-container").hide();
                } else {
                    editorSelector.closest(".notes-textarea-container").hide();
                    editorSelector.closest(".notes-textarea-container").children("iframe").hide();
                    textAreaSelector.parents(".notes-textarea-container").show();
                }

                $.wait(10).then(function () {
                    selectFirstRowOrSelectedRow({ grid: grid, e: e });
                });
            },
            saveChanges: function (e) {
                if (e.sender.dataSource._destroyed.length > 0) {
                    e.sender.dataSource._destroyed = new Array();
                }
            }
        });
        me.notesGrid.kendoGrid.table.off("click").on("click", ".k-grid-delete", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (!screen[me.selectedNoteVariableName].Id) {
                screen[me.selectedNoteVariableName] = null;
                me.notesGrid.refresh();
                $(me.allButtonSelector).enableAll(true);
                return;
            }
            z.util.deleteEntity({
                id: screen[me.selectedNoteVariableName].Id,
                entity: me.destinationType + "Note",
                friendlyEntityName: "Note",
                success: function () {
                    me.notesGrid.kendoGrid.dataSource.read();
                }
            });
        });
    },
    bindNoteEvents: function () {
        var me = this,
            screen = me.screen;

        var newNoteFn = function () {
            $(me.allButtonSelector).disableAll(true);
            var firstNote = me.noteDS && me.noteDS.data()[0],
                grid = $("#" + me.gridId).data("kendoGrid");

            if (firstNote && firstNote.Contents == "") {
                if (firstNote.Id == null) {
                    me.noteDS.remove(firstNote);
                } else {
                    grid.tbody.find("tr:first").find(".k-grid-delete").click();
                }
            }

            let noteTypeId = z.codes.NoteType[1].Id,
                commentNoteTypeCodeNumber = z.util.getOptionValue("DefaultCommentOrderNoteType"),
                commentNoteType = commentNoteTypeCodeNumber
                    && _.find(z.codes.NoteType, (noteType) => noteType.CodeNumber == commentNoteTypeCodeNumber);

            if (me.noteType == "Order" && commentNoteType) {
                noteTypeId = commentNoteType.Id;
            }

            me.noteDS.insert(0, {
                CreatedUser: z.user.name,
                CreatedDateTime: new Date(),
                NoteTypeId: noteTypeId,
                Contents: "",
                NewNote: true
            });

            grid.one("dataBound", function (e) {
                grid.select(e.sender.tbody.find("tr:first"));
                $.wait(10).then(() => {
                    $(grid.content).scrollTop(0);
                });
                $.wait(250).then(() => {
                    $(grid.content).scrollTop(0);
                });
            });

            grid.setDataSource(me.noteDS);

            $("#" + me.contentAreaId).addClass("hidden");

            var textArea = me.isEditor ? $(`#${me.editorId}`) : $(`#${me.textAreaId}`);

            if (me.isEditor) {
                textArea.data("kendoEditor").focus();
            } else {
                textArea.focus();
            }
            me.isFocused = true;
            grid.refresh();
        };

        if (me.readOnly) {
            $(`#${me.newNoteId}`).disableAll();
        } else {
            $(`#${me.newNoteId}`).off("click").tie("click", function () {
                newNoteFn();
            });
        }

        me.noteTextArea = me.isEditor ? $($(`#${me.editorId}`).data("kendoEditor").body) : $(`#${me.textAreaId}`);

        if (!me.readOnly) {
            $(me.noteTextArea).off("click").tie("click", function () {
                if ($.trim(me.noteTextArea.val()) == "" && !screen[me.selectedNoteVariableName]) {
                    newNoteFn();
                }
            });
        }

        $(me.noteTextArea).off("focus").tie("focus", function () {
            me.isFocused = true;
            $(me.allButtonSelector).disableAll(true);
        });

        var isNoteTypeOpen = function (args) {

            if (args.selectedRowNoteType && args.selectedRowNoteType.wrapper.hasClass("k-state-border-down")) {
                if (args.selectedNote && args.noteValue != args.value) {
                    args.selectedNote.Contents = args.value;
                    args.selectedNote.dirty = true;
                }
                return true;
            }
            return false;
        };

        var updateNote = function (args) {
            if (me.ignoreUpdate) {
                me.ignoreUpdate = false;
                $(me.allButtonSelector).enableAll(true);
                return;
            }

            if (!args.selectedNote) {
                me.noteDS.insert(0, {
                    CreatedUser: z.user.name,
                    CreatedDateTime: new Date(),
                    NoteTypeId: z.codes.NoteType[1].Id,
                    Contents: args.value
                });
                args.grid.saveChanges();
            } else if (args.noteValue != args.value || !args.selectedNote.Id || args.selectedNote.dirty) {
                args.selectedNote.Contents = args.value;
                args.selectedNote.dirty = true;
                args.grid.saveChanges();
            } else {
                $(me.allButtonSelector).enableAll(true);
            }
        };

        var runAfterBlur = function (args) {
            if (!isNoteTypeOpen(args)) {
                if ($.trim(args.value) != "") {
                    updateNote(args);
                } else if ($.trim(args.value) == "" && args.selectedNote && me.noteDS.getByUid(args.selectedNote.uid)) {
                    $(me.allButtonSelector).enableAll(true);
                    if (args.selectedNote.Id == null) {
                        me.noteDS.remove(args.selectedNote);
                        screen[me.selectedNoteVariableName] = null;
                    } else {
                        args.selectedRow.find(".k-grid-delete").click();
                    }
                }
            }
        };

        $(me.noteTextArea).off("blur").on("blur", function () {
            me.isFocused = false;
            var selectedNote = screen[me.selectedNoteVariableName],
                noteValue = selectedNote && selectedNote.Contents || "",
                grid = $("#" + me.gridId).data("kendoGrid"),
                selectedRow = grid.select(),
                selectedRowNoteType = selectedRow.find(".note-type .k-combobox > input").data("kendoComboBox");

            var args = {
                value: me.isEditor ? me.readyNoteForEditor($(`#${me.editorId}`).data("kendoEditor").value()) : me.readyNoteForTextArea($(this).val()),
                selectedNote: selectedNote,
                noteValue: noteValue,
                grid: grid,
                selectedRow: selectedRow,
                selectedRowNoteType: selectedRowNoteType
            };

            if ($.trim(args.value) != "") {
                $.wait(200).then(function () {
                    if (me.preventBlur) {
                        me.preventBlur = false;
                    } else {
                        if (!me.noteTextArea.is(":focus")) {
                            runAfterBlur(args);
                        }
                    }
                });
            } else {
                me.preventBlur = false;
            }
        });

        if (me.isEditor) {
            var editor = $(`#${me.editorId}`).data("kendoEditor");
            editor.unbind("keydown").bind("keydown", function (e) {
                if (e.keyCode == 9) {
                    e.preventDefault();
                    $(editor.body).blur();
                }
            });
        } else {
            $(`#${me.textAreaId}`).off("keydown").tie("keydown", function (e) {
                if (e.keyCode == 9) {
                    e.preventDefault();
                    $(this).blur();
                }
            });
        }

        $(`#${me.editorId}`).data("kendoEditor").unbind("execute").bind("execute", (e) => {
            if (e.name == "createlink") {
                me.preventBlur = true;
            }
            me.isFocused = true;
            me.noteTextArea.focus();
        });

        var noteInsert = $("#" + me.insertId);
        if (me.readOnly) {
            noteInsert.disableAll();
        } else {
            noteInsert.off("click").tie("click", function () {
                z.util.uploadDocuments({
                    entity: me.noteType,
                    saveUrl: "Note/Upload/",
                    Id: me.screen[me.observableName][me.modelObservableId],
                    successEntity: "Note",
                    screen: me.screen,
                    gridId: me.gridId
                });
            });
        }
    },
    createNoteDataSource: function () {
        var me = this;
        const filterId = me.screen[me.observableName][me.modelObservableId];
        me.noteDS = filterId
            ? z.dataSource({
                parent: $(`#${me.gridId}`),
                transport: {
                    read: {
                        url: function () {
                            if (me.noteType == "Order") {
                                return "Order/RelatedNotes";
                            } else if (me.noteType == "Quote") {
                                return "Quote/RelatedNotes";
                            } else {
                                return `${me.noteType}Note`;
                            }
                        }
                    },
                    update: {
                        url: function (options) {
                            return `${me.destinationType}Note`;
                        }
                    },
                    create: {
                        url: `${me.noteType}Note`
                    },
                    parameterMap: function (data, type) {
                        var model;
                        if (type == "create") {
                            model = data.models[0];
                            model[me.modelId] = filterId;
                            delete model.CreatedUser;
                            delete model.CreatedDateTime;
                            delete model.NewNote;
                            return JSON.stringify(model);
                        }

                        if (type == "update") {
                            model = data.models[0];
                            delete model.CreatedUser;
                            delete model.CreatedUserId;
                            delete model.CreatedDateTime;
                            delete model.Attachment;
                            delete model.AttachmentId;
                            return JSON.stringify(model);
                        }

                        if (data.sort) {
                            $.each(data.sort, function (index, sort) {
                                if (sort.field == "CreatedUser") {
                                    sort.field = "CreatedUser/FirstName";
                                }
                            });
                        }
                        if (data.filter && data.filter.filters) {
                            $.each(data.filter.filters, function (index, filter) {
                                if (filter.field == "CreatedUser") {
                                    filter.field = "CreatedUser/FirstName";
                                }
                            });
                        }

                        return z.util.buildODataKendoParams({
                            data: data,
                            filterExpression: `${me.filterIdVariable}Id eq ${filterId}`,
                            selectExpression: `Id, Contents, CreatedDateTime, CreatedUserId, NoteTypeId, Attachment/*, DestinationType, MobileCreatedDateTime, CreatedUser/FirstName, CreatedUser/LastName, CreatedUser/EmployeeNumber${me.noteType == "Contract" ? ", CopyToCreatedOrders" : ""}`,
                            expandExpression: "CreatedUser, Attachment",
                            sortExpression: "CreatedDateTime desc"
                        });
                    }
                },
                requestEnd: function (e) {
                    var validResults = (e.response && e.response.d && e.response.d.results);
                    if (e.type != "read") {
                        if (validResults) {
                            me.updatedNoteId = e.response.d.results;
                            z.controls.alert({ type: "success", header: z.ll("SaveSuccessful"), message: z.ll("SaveSuccessfulMessage").format(z.ll("Note")) });
                        } else if (e.type != "destroy" && !e.type) {
                            z.controls.alert({ type: "danger", header: z.ll("SaveFailed"), message: z.ll("SaveFailedMessage").format(z.ll("Note")) });
                        }
                        me.attachment = false;
                        e.sender.read();
                    } else if (validResults) {
                        $.each(e.response.d.results, function (index, result) {
                            if (result.CreatedUser) {
                                result.CreatedUser = z.util.buildFullName(result.CreatedUser.FirstName, result.CreatedUser.LastName, result.CreatedUser.EmployeeNumber);
                            } else {
                                result.CreatedUser = "---";
                            }
                        });
                    }
                    var grid = $("#" + me.gridId).data("kendoGrid");
                    grid.content.find(".grid-instructions-container").remove();
                    $(".editor-overlay").hide();
                    $("#" + me.textAreaId).enable();
                    $(me.allButtonSelector).enableAll(true);

                    if ($("#" + me.gridId).children().hasClass("disabled")) {
                        $("#" + me.newNoteId).disableAll();
                        $("#" + me.newNoteId).disable();
                        $("#" + me.insertId).disableAll();
                        $("#" + me.insertId).disable();
                    }

                },
                requestStart: function (e) {
                    var grid = $("#" + me.gridId).data("kendoGrid");
                    if (e.type == "read") {
                        grid.content.append(z.util.newLoadingMask({ instructions: z.ll("LoadingGridData") }));
                    } else {
                        grid.content.append(z.util.newLoadingMask({ instructions: z.ll("SavingGridData") }));
                    }
                    if (me.isEditor) {
                        $(".editor-overlay").show();
                    } else {
                        $("#" + me.textAreaId).disable();
                        $(me.allButtonSelector).disableAll(true);
                    }
                },
                schema: {
                    model: {
                        id: "Id",
                        fields: {
                            CreatedDateTime: { editable: false },
                            CreatedUser: { editable: false },
                            NoteTypeId: { editable: true },
                            Contents: { editable: false },
                            CopyToCreatedOrders: { editable: true }
                        }
                    }
                }
            })
            : new kendo.data.DataSource({ data: [] });
    },
    refreshNoteGrid: function (args) {
        var me = this,
            screen = me.screen;

        me.createNoteDataSource();
        screen[me.selectedNoteVariableName] = null;
        me.refreshNoteDataSource();

        if ($("#" + me.newNoteId).hasClass("disabled")) {
            $("#" + me.newNoteId).disableAll();
            $("#" + me.insertId).disableAll();
        }

        me.refreshEditor();
    },
    refreshNoteDataSource: function () {
        var me = this,
            grid = $("#" + me.gridId).data("kendoGrid");

        if (grid) {
            grid.setDataSource(me.noteDS);
            $("#" + me.textAreaId).enable();
            $("#" + me.newNoteId + ", #" + me.insertId).enableAll(true);
        }
        $("#" + me.gridId).data("me").refresh();
    },
    resetNotes: function () {
        var me = this,
            textArea = $("#" + me.textAreaId);

        $("#" + me.contentAreaId).addClass("hidden");
        textArea.parents(".notes-textarea-container").show();
        textArea.val("");
    },
    refreshEditor: function () {
        const me = this,
            editor = $(`#${me.editorId}`).data("kendoEditor");

        if (editor) {
            editor.refresh();

            if (me.readOnly) {
                let editorBody = $(editor.body);

                editorBody.attr("contenteditable", "false");
                editor.element.closest(".k-editor-widget").find(".k-editor-toolbar-wrap").hide();
            }

            me.bindNoteEvents();
        }
    },
    readyNoteForEditor: function (noteContents) {
        var result, length;
        result = noteContents.replaceAll("\n", "<br/>");
        // Repeatedly removes tags without text until no change is detected.
        while (length != result.length) {
            length = result.length;
            result = result.replaceAll(new RegExp(`<[a-zA-Z "\\-:;=]+>[\\s]*</[a-zA-Z]+>`), "");
        }
        return result;
    },
    readyNoteForTextArea: function (noteContents) {
        return z.util.stripHTML({
            html: noteContents,
            insertLineBreaks: true,
        });
    }
};

export default Notes;
